var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-w-full"},[_c('div',{staticClass:" align-right ",class:{focus: _vm.isFocusing || _vm.currentValue}},[_c('v-select',{attrs:{"items":_vm.items,"value":"ปี 2565","filled":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }